import { Emoji, unifiedToNative } from 'shared/entities/emoji';

export type EmojiInsertSelection =
  | Emoji
  | { native?: string; unified?: string };

export function emojiSelectionToInsertText(
  selected: EmojiInsertSelection
): string {
  if (selected.native && selected.native.length > 0) {
    return selected.native;
  }
  if (selected.unified) {
    return unifiedToNative(selected.unified);
  }
  return '';
}
